import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import useOrderTypes from '@/composables/useOrderTypes';
import WCMobileOTSwitcher from '@/components/WCMobileOTSwitcher/WCMobileOTSwitcher.vue';
import useEmployee from '@/modules/employee/composables/useEmployee';
import { configurationKey } from '@/injections';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCMobileNavBarModern',
  setup(__props) {

const { isNotAnEmployee } = useEmployee();
const route = useRoute();
const { visibleOrderTypes } = useOrderTypes();
const configuration = inject(configurationKey);
const orderTypesEnabled = computed(() => configuration?.orderTypesEnabled);
const showOTSwitcher = computed(() => (visibleOrderTypes.value?.length ?? 0) > 1);

return (_ctx: any,_cache: any) => {
  return (_unref(isNotAnEmployee) && _unref(route).name !== 'Gift Card')
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (orderTypesEnabled.value && showOTSwitcher.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(WCMobileOTSwitcher)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})